<div class="preamble">
  <h2>Self audit</h2>
</div>

<p>
  As this is a subsequent notification you must conduct a self audit before you
  can continue with this notification.
</p>
<form [formGroup]="form" class="form">
  <ol class="questions">
    <li class="group">
      <legend>
        <span class="label"
          >Have you undertaken a self-audit of the clearing undertaken, and was
          the clearing consistent with the code requirements?</span
          >
          <abbr title="(required)" class="required">*</abbr>
        </legend>
        <ul class="choices">
          <li>
            <input type="radio" [value]="true" formControlName="hasAuditEvidence" id="hasAuditEvidence-yes" />
            <label for="hasAuditEvidence-yes"> Yes </label>
          </li>
          <li>
            <input type="radio" [value]="false" formControlName="hasAuditEvidence" id="hasAuditEvidence-no" />
            <label for="hasAuditEvidence-no"> No </label>
          </li>
        </ul>
      </li>
      @if (hasAuditEvidenceControl.value === true && form.dirty) {
        <div class="alert alert-info">
          You are required to keep records of your clearing activities and make them
          available to the Department of Natural Resources and Mines, Manufacturing and Regional and Rural Development upon request.
        </div>
      }
      @if (!hasAuditEvidenceControl.value && form.dirty) {
        <div class="alert alert-warning">
          You cannot continue until you have undertaken a self audit. If you need
          assistance please contact us.
        </div>
      }
    </ol>

    <li class="footer">
      <ul class="actions">
        <li>
          <input class="qg-btn btn-global-secondary" type="button" (click)="previous()" value="Previous" />
        </li>
        <li>
          <em><input class="qg-btn btn-primary" type="submit" (click)="next()" value="Next" /></em>
        </li>
      </ul>
    </li>
    <ul class="actions">
      <li>
        <a href (click)="cancel()">Cancel</a>
      </li>
    </ul>
  </form>
